export const fetchTrainingsData = async (setTrainings, setLoading, setError) => {
    const calendarApiUrl = process.env.REACT_APP_CALENDAR_API_URL || process.env.REACT_APP_API_URL;
    const date = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format
    const response = await fetch(`${calendarApiUrl}/api/calendar?date=${date}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const data = await response.json();

    if (!response.ok || !Array.isArray(data)) {
        setError(true);
        setLoading(false);
        return;
    }

    setTrainings(data);
    setLoading(false);
};

export const fetchMoreTrainings = async (fromDate) => {
    const calendarApiUrl = process.env.REACT_APP_CALENDAR_API_URL || process.env.REACT_APP_API_URL;
    const response = await fetch(`${calendarApiUrl}/api/calendar?date=${fromDate}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    const data = await response.json();

    if (!response.ok || !Array.isArray(data)) {
        return [];
    }

    return data;
};
